<div class="chat-message" [ngClass]="{'user-message': message.type === 'user', 'ai-message': message.type === 'ai'}">
  <!-- <p [innerHTML]="message.message"></p> -->
  <p appExpandableText [appExpandableText]="message.message" [maxLength]="500" readMoreText="Show more" readLessText="Show less"></p>
  <span class="timestamp">{{ message.timestamp | date: 'MM/dd/yyyy HH:mm' }}</span>
</div>
